import React from "react";
import { Checkbox } from "@mantine/core";

const RowCheckbox = ({ checked, onChange, onClick, ...rest }) => {
	const handler = onChange || onClick;
	return (
		<Checkbox checked={checked} onChange={handler} size="xs" {...rest} />
	);
};

export { RowCheckbox };
